import createReducer from "./../createReducer";
import { IConfigState } from "./types";
import { handlersConfigs } from "./handlers";

export const configInitialState: IConfigState = {
    config: {
        stop_writing_warn: false,
        leave_field_warn: false,
        show_via_tooltip: false,
        show_all_errors: false,
    },
};

export default createReducer(configInitialState, handlersConfigs);
